declare var $: any;
import {  Component, NgZone, OnInit } from '@angular/core';
import * as alertFunctions from '../shared/data/sweet-alerts';
import { CommonService } from '../shared/common.service';
import { Router, ActivatedRoute } from "@angular/router";
import { BrowserModule, Title } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
//import { Console } from 'console';

@Component({
  selector: 'app-visitgrid',
  templateUrl: './visitgrid.component.html',
  styleUrls: ['./visitgrid.component.css'],
  providers: [CommonService]
})
export class VisitgridComponent implements OnInit {

  public fromDateModel: NgbDateStruct | null = null;
  public toDateModel: NgbDateStruct | null = null;
    public aarthibranch:any=[];
    public patients:any=[];
    public fromDate:any;
    public toDate:any;
    public selectsearchtype:any;
    public locations:any=[];

    public selected:any;
    public filtered :any;
    public SIDNo:String="";
    public PatientName:String="";
    public Client_Ref_No:String="";
    public BranchCode:String="";
    public sidNo:String="";
    public patientName:String="";
    public LoginType:String="";
    public searchText:any;
    public isBranchUser:any;
    public isSuperUser : any;
    public userName : any;

  constructor(private titleService: Title,private router: Router, private route: ActivatedRoute,private http:CommonService,private zone: NgZone) {
    this.titleService.setTitle("Dashboard");
   }

  

  fromdatechange(event: NgbDate) {
    if (!event) {
      return;
    }

    const fromJsDate = new Date(event.year, event.month - 1, event.day);

    fromJsDate.setDate(fromJsDate.getDate() + 1);

    this.toDateModel = {
      day: fromJsDate.getDate(),
      month: fromJsDate.getMonth() + 1,
      year: fromJsDate.getFullYear(),
    };

    console.log('From Date selected:', event);
    console.log('To Date model set to:', this.toDateModel);
  }
 

  ngOnInit(): void {   

    var headersmartreport = document.getElementById("headersmartreport");
    // headersmartreport.style.display = 'none'; 

    // if((sessionStorage.getItem("refcode")==null || sessionStorage.getItem("refcode")=="" || sessionStorage.getItem("refcode")==undefined))
    // {
    //   window.location.href=environment.LoginURL+sessionStorage.getItem("LoginType");
    // }

    
   this.LoginType=sessionStorage.getItem("LoginType");
   this.isBranchUser = sessionStorage.getItem("Branch_User");
   this.isSuperUser =  sessionStorage.getItem("Super_User");
   this.userName = sessionStorage.getItem("refcode");
   

       let path="locations?userName=" + this.userName + "&isBranchuser=" + this.isBranchUser + "&isSuperuser=" + this.isSuperUser;
       this.http.GET(path).subscribe(data=>{
           if(data["locations"]){
           var result=data["locations"];           
           this.locations=result;
           this.BranchCode='ALL';            
           }
           else{                          
              alertFunctions.typeError("Web Api returned error");
               return false;
           }
       });
       setTimeout(() => {
           this.setInitialDates();
           this.FetchData();
           
       }, 500);
       

  }
  onOptionsSelected() {    
    this.filtered = this.patients.filter(t=>t.value ==this.selected);

}     



private setInitialDates(): void {
  const today = new Date();
  const fromDate = new Date();

  // if (this.isBranchUser === "1") {
    fromDate.setDate(fromDate.getDate() - 1); // Yesterday
  // } else {
  //   fromDate.setDate(fromDate.getDate() - 7); // A week ago
  // }

  // 2. Convert the JavaScript Date objects into NgbDateStruct objects,
  //    which is the format the datepicker model expects.
  this.fromDateModel = this.convertJsDateToNgbDate(fromDate);
  this.toDateModel = this.convertJsDateToNgbDate(today);

  console.log("Initial From Date model set to:", this.fromDateModel);
  console.log("Initial To Date model set to:", this.toDateModel);
}

/**
 * Helper function to convert a standard JS Date to an NgbDateStruct.
 */
private convertJsDateToNgbDate(date: Date): NgbDateStruct {
  return {
    
     // JS Date month is 0-11, NgbDateStruct is 1-12
    day: date.getDate(),
    month: date.getMonth() + 1,
    year: date.getFullYear() 
  };
}



private formatNgbDateForApi(date: NgbDateStruct | null): string | null {
  if (!date) {
    return null;
  }

  const month = date.month < 10 ? '0' + date.month : date.month;
  const day = date.day < 10 ? '0' + date.day : date.day;

  return `${date.year}/${month}/${day}`;
}


  
FetchData(){  
 

  if(this.BranchCode == "" || this.BranchCode == null || this.BranchCode == undefined)
  {
    this.BranchCode = 'ALL';
    
  }
  sessionStorage.setItem("selectedBranch",String(this.BranchCode));   
     var refCode : any;
    if ((this.isBranchUser == "0")  && (this.isSuperUser == "0") && sessionStorage.getItem("refcode") != null)
        refCode = sessionStorage.getItem("refcode");
    else if ((this.isSuperUser == "1") && (this.BranchCode != "ALL"))
        refCode = this.BranchCode;
    else if ((this.isSuperUser == "1") && (this.BranchCode == "ALL") && (sessionStorage.getItem("refcode") != null))
      refCode = sessionStorage.getItem("refcode")
    else refCode = "";
  

    var item={
        "mobile": "",
        "from_Date": this.formatNgbDateForApi(this.fromDateModel),
        "to_Date": this.formatNgbDateForApi(this.toDateModel),    
        "branch_Code": this.BranchCode == "ALL" || this.isSuperUser == "1"? "" : this.BranchCode,
        //"ref_Code": ((this.isBranchUser == 0) && sessionStorage.getItem("refcode") != null) ?sessionStorage.getItem("refcode"):"",
        "ref_Code": refCode,
        "pt_Code": "",
        "sid_No": this.SIDNo.trim(),
        "patient_Name": this.PatientName.trim(),
        "Client_Ref_No" : this.Client_Ref_No.trim(),
        "is_Branch_User": this.isBranchUser,
        "is_Super_User": this.BranchCode == "ALL" ? this.isSuperUser : "0",
        "userName": this.userName.trim()
    }
    
    let path="visits/organisation";
    // this.http.fnShowLoading();
    this.http.POST(path,item).subscribe(data=>{
      //console.clear();
      
        this.http.fnHideLoading();
        if(data["patients"]){
        var result=data["patients"];
        this.patients=result;
        
        }
        else{
           alertFunctions.typeError("Web Api returned error");
           return false;
        }
    })
}
  PatientTimeLine(MobileNo,PtCode,PatientName,Client_Ref_No) {
    sessionStorage.setItem("MobileNo",MobileNo);
    sessionStorage.setItem("PtCode",PtCode);
    sessionStorage.setItem("PatientName",PatientName); 
    sessionStorage.setItem("Client_Ref_No",Client_Ref_No); 
       
    //this.router.navigate(["visitgriddetails"]);
    window.open('/ReportsPortal/#/visitgriddetails', '')
  }

  reset() {
    this.SIDNo = '';
    this.PatientName = '';
    this.Client_Ref_No = '',
    this.BranchCode = 'ALL';    
    this.setInitialDates();
  }

}
